import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrudService } from '../../../shared/services/crud.service';
import { Owner } from './owner.types';

@Injectable({
    providedIn: 'root'
})
export class OwnerService extends CrudService<Owner> {
    constructor(protected http: HttpClient) {
        super(http, 'owner');
    }
}
